import { Box } from '@mui/material';
import React from 'react';

const PrivateFooter = () => {
  return <Box p={2}></Box>;
};

export default PrivateFooter;
